import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArmEllipsisTooltipDirective } from './arm-ellipsis-tooltip/arm-ellipsis-tooltip.directive';



@NgModule({
  declarations: [ArmEllipsisTooltipDirective],
  exports: [
    ArmEllipsisTooltipDirective
  ],
  imports: [
    CommonModule
  ]
})
export class ArmDirectivesModule { }
